import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialogContent']
  static outlets = ['ui--modal--dialog']

  DIALOG_ID = 'modal-dialog-singleton'
  DIALOG_OPEN_CLASS = 'components--modal__dialog--open'
  DIALOG_CONTROLLER = 'ui--modal--dialog'

  connect() {
    // needed here in case frame is loaded before modal opens
    this.element.addEventListener('turbo:frame-load', this.uiModalDialogOutlet.handleFrameLoad)
    this.element.addEventListener('modal:open', this.handleOpen)
  }

  disconnect() {
    this.element.removeEventListener('turbo:frame-load', this.uiModalDialogOutlet.handleFrameLoad)
    this.element.removeEventListener('modal:open', this.handleOpen)
  }

  handleOpen = () => {
    this.uiModalDialogOutlet.open(this.dialogContentTarget)
  }
}
